export interface Dimension {
  description: string;
  name: string;
  show_advisor_filter: boolean;
}

export interface Collection {
  access_list: string[];
  collection_id: string;
  description: string;
  dimensions: Dimension[];
  id?: string;
  name: string;
  is_hidden: boolean;
  is_private?: boolean;
  private?: boolean;
  context?: CollectionContext;
  owner_id: string;
}

export enum CollectionContext {
  REGULATORY = 'regulatory',
  RFP = 'rfp'
}

export interface CommonDimensions {
  company: string;
  state: string;
  year: string;
  title: string;
  [dimensionAttribute: string]: string;
}

// A file in a collection (response from API)
export interface FileMetadata {
  catalogue?: CommonDimensions;
  collection_id: string;
  file_id: string;
  processing_stage: 'started' | 'image_extraction' | 'text_extraction' | 'preindexing' | 'complete' | 'failed' | '';
  original_document_uri: string;
  s3_output_path: string;
}

export interface RowData extends CommonDimensions {
  collection_id: string;
  file_id: string;
  processing_stage: 'started' | 'image_extraction' | 'text_extraction' | 'preindexing' | 'complete' | 'failed' | '';
  original_document_uri: string;
  s3_output_path: string;
}

export interface CollectionsLinks {
  links: [
    {
      file_name: string;
      url: string;
    }
  ];
}
